var youboralib = require('youboralib')
var Util = youboralib.Util

module.exports = {
  isUsed: function (adapter) {
    return adapter.player.dash && adapter.player.dash.shakaPlayer
  },

  getResource: function (adapter) {
    return adapter.player.dash.shakaPlayer.getManifestUri()
  },

  getBitrate: function (adapter) {
    return adapter.player.dash.shakaPlayer.getStats().streamBandwidth
  },

  getRendition: function (adapter) {
    var tracks = adapter.player.dash.shakaPlayer.getVariantTracks()
    for (var i in tracks) {
      var track = tracks[i]
      if (track.active && track.type === 'video') {
        return Util.buildRenditionString(track.width, track.height, track.bandwidth)
      }
    }
    var width = adapter.player.dash.shakaPlayer.getStats().width
    var height = adapter.player.dash.shakaPlayer.getStats().height
    var bitrate = adapter.player.dash.shakaPlayer.getStats().streamBandwidth
    return Util.buildRenditionString(width, height, bitrate)
  }
}
